const LIREN_PROJECT_ALIASES = ['lxqsnwxj', 'lxxjjlh', 'lxqsnwhzy'];
const SHAOXING_CULTURE_ALIASES = ['lxwhz', 'gxzz'];

function redirectToProjectAggregate(to, from, next) {
  const { catalogAlisa } = to.query;
  let path = '';

  if (LIREN_PROJECT_ALIASES.includes(catalogAlisa)) {
    path = '/project/liren-education';
  } else if (SHAOXING_CULTURE_ALIASES.includes(catalogAlisa)) {
    path = '/project/shaoxing-culture';
  }

  if (path) {
    next({
      path,
      query: { catalogAlisa },
      replace: true,
    });
    return;
  }

  next();
}

export default [
  {
    path: '/project',
    name: 'project',
    component: () => import('@/views/project/index.vue'),
    meta: {
      title: '项目中心',
    },
  },
  {
    path: '/project/list',
    name: 'project-list',
    component: () => import('@/views/project/list.vue'),
    beforeEnter: redirectToProjectAggregate,
    meta: {
      title: '项目中心',
    },
  },
  {
    path: '/project/list2',
    name: 'project-list2',
    component: () => import('@/views/project/list2.vue'),
    meta: {
      title: '项目中心',
    },
  },
  {
    path: '/project/liren-education',
    name: 'project-liren-education',
    component: () => import('@/views/project/liren-education.vue'),
    meta: {
      title: '立人教育',
    },
  },
  {
    path: '/project/shaoxing-culture',
    name: 'project-shaoxing-culture',
    component: () => import('@/views/project/shaoxing-culture.vue'),
    meta: {
      title: '绍兴文化事业发展',
    },
  },
  {
    path: '/project/detail',
    name: 'project-detail',
    component: () => import('@/views/project/detail.vue'),
    meta: {
      title: '项目详情',
    },
  },
];
